export default __webpack_public_path__ + "static/media/logo-home-1.3f463bf6.png";